import 'intersection-observer';

function getScrollX() {
  let nowWindow = window;
  if (window.iframeWindow) {
    nowWindow = window.iframeWindow;
  }
  const nowDocument = nowWindow.document;

  return nowWindow.pageXOffset !== undefined
    ? nowWindow.pageXOffset
    : (
      nowDocument.documentElement
        || nowDocument.body.parentNode
        || nowDocument.body
    ).scrollLeft;
}
function getScrollY() {
  let nowWindow = window;
  if (window.iframeWindow) {
    nowWindow = window.iframeWindow;
  }
  const nowDocument = nowWindow.document;

  return nowWindow.pageYOffset !== undefined
    ? nowWindow.pageYOffset
    : (
      nowDocument.documentElement
        || nowDocument.body.parentNode
        || nowDocument.body
    ).scrollTop;
}

function getNowWindow() {
  let nowWindow = window;
  if (window.iframeWindow) {
    nowWindow = window.iframeWindow;
  }
  return nowWindow;
}

function rem2px(rem) {
  if (!rem) {
    return 0;
  }
  const nowWindow = getNowWindow();
  const nowDocument = nowWindow.document;
  const nowHtml = nowDocument.getElementsByTagName('html')[0];
  const { fontSize } = nowHtml.style;
  const fontSizeNum = Number(fontSize.substr(0, fontSize.length - 2));
  const remNum = Number(rem.substr(0, rem.length - 3));

  return remNum * fontSizeNum;
}

function callback(entries, cb, offset) {
  const { top: topOffset } = offset;

  entries.forEach((entry) => {
    const { boundingClientRect } = entry;
    const { top, left, height, width } = boundingClientRect;
    let direction = '';
    if ((top + topOffset) < 0 && height && width) {
      direction = 'top';
    }
    const detail = {
      leave: !entry.isIntersecting,
      top,
      left,
      y: getScrollY() + top,
      x: getScrollX() + left,
      height,
      width,
      direction,
    };

    cb(detail);
  });
}

class CompInterObserver {
  constructor() {
    this.interObserverList = [];
    this.listenedCompMap = {};
    this.compMap = {};
  }

  initObserver() {}

  // 监听特定组件
  onCompChange(compId, cb, config) {
    const callbackConfig = {
      cb,
      config,
      observed: false,
    };

    if (this.listenedCompMap[compId]) {
      this.listenedCompMap[compId].callbackList.push(callbackConfig);
    } else {
      this.listenedCompMap[compId] = {
        callbackList: [callbackConfig],
      };
    }

    const el = document.getElementById(compId);
    this.observe(el, compId);
  }

  addComp(el) {
    const compId = el.id;
    if (this.compMap[compId]) {
      return;
    }
    this.observe(el, compId);
  }

  observe(el, compId) {
    if (!el || !(el instanceof HTMLElement)) {
      return;
    }
    if (!this.compMap[compId]) {
      this.compMap[compId] = el;
    }
    if (!this.listenedCompMap[compId]) {
      return;
    }
    const { callbackList } = this.listenedCompMap[compId];

    if (callbackList) {
      callbackList.forEach((item, index) => {
        if (item.observed) {
          return;
        }
        callbackList[index].observed = true;
        const { cb, config } = item;

        // 获得rootMargin
        const rootMarginObject = config.rootMargin || {};
        const top = rem2px(rootMarginObject.top) || 0;
        const right = rem2px(rootMarginObject.right) || 0;
        const bottom = rem2px(rootMarginObject.bottom) || 0;
        const left = rem2px(rootMarginObject.left) || 0;
        const rootMargin = `${top}px ${rem2px(right) || 0}px ${rem2px(bottom) || 0}px ${rem2px(left) || 0}px`;
        const options = { rootMargin, root: null, threshold: 0.000001 };


        const interObserver = new IntersectionObserver(
          (entries) => {
            callback(entries, cb, { top, right, left, bottom });
          },
          options,
        );

        interObserver.observe(el);

        this.interObserverList.push(interObserver);
      });
    }
  }
}

export default new CompInterObserver();
